import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { ChangePassword } from './change-password.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { PasswordStrengthValidator } from '../../shared/validator/password-strength.validators';
import { MustMatch } from '../../shared/validator/must-match.validator';
import { first } from 'rxjs/operators';
import { MustNotMatch } from '../../shared/validator/must-not-match.validator';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { User } from '../../shared/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  loading = false;
  submitted = false;
  responseObject: ResponseObject;
  userName: string = '';
  confirmationCode: string = '';
  changePassword: ChangePassword = new ChangePassword();
  user: User = new User();
  showRequest=false;
  constructor(private formBuilder: FormBuilder,
    private alertService: AlertService,
    private userService: UserService,
    private router: Router,
    private authSrevice: AuthenticationService,
    private translate: TranslateService,
    private global : GlobalServices) {

    this.user = this.authSrevice.currentUserValue;
  }


  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.changePasswordForm = this.formBuilder.group({
      username: [''],
      oldpassword: ['', Validators.required],
      newpassword: ['', [Validators.required, PasswordStrengthValidator]],
      confirmpassword: ['', Validators.required]
    },
      {
        validator: MustMatch('newpassword', 'confirmpassword'),
        validatorNotMatch: MustNotMatch('oldpassword', 'newpassword')
      }
    );

  }
  get f() {
    return this.changePasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    this.alertService.clear();
    // stop here if form is invalid
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.loading = true;
    
    this.global.isLoaderEnabled = true;
    this.changePassword.OldPassword = this.global.encryptPassword(this.changePasswordForm.controls.oldpassword.value);
    this.changePassword.UserName = this.user.UserName;
    this.changePassword.NewPassword = this.global.encryptPassword(this.changePasswordForm.controls.newpassword.value);
    this.changePassword.ConfirmNewPassword = this.global.encryptPassword(this.changePasswordForm.controls.confirmpassword.value);

    this.userService.ChangePassword(this.changePassword)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          this.responseObject = data;
          if (this.responseObject.Success) {
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.CHANGE_PASSWORD'), false);
            this.global.isLoaderEnabled = false;
            this.showRequest=true;
            this.authSrevice.logout()
              .subscribe((result: ResponseObject) => {
                this.authSrevice.currentUserSubject.next(null);

                this.global.goToHome();
              });

            this.loading = false;
          }
          else {  
            
            this.global.isLoaderEnabled = false;
            this.showRequest=false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+this.responseObject.ErrorMessages[0]), false);
            this.loading = false;
          }

        });
  }

}
